import {
  Separator as RACSeparator,
  SeparatorProps,
} from "react-aria-components"

const Separator = (props: SeparatorProps) => {
  return <RACSeparator {...props} className="separator" />
}

export default Separator
